/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type LockCardResponseProductCardImageDetailsOneOfCardOrientation = typeof LockCardResponseProductCardImageDetailsOneOfCardOrientation[keyof typeof LockCardResponseProductCardImageDetailsOneOfCardOrientation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LockCardResponseProductCardImageDetailsOneOfCardOrientation = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
} as const;
